// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"_-ui-admin-lib-ModalTitle-index-module__modalTitle--1leJR"};